import React from "react";

// Chakra imports
import { Flex } from "@chakra-ui/react";
import Logo from "../../../assets/img/Logo_without_teg.svg";


export function IconBrand() {
  //   Chakra color mode

  return (
    <Flex h={100} justifyContent="center" direction="column" className="logo-container" paddingLeft={1}>
      <img src={Logo} alt="logo" style={{ width: "100px" }} />
    </Flex>
  );
}

export default IconBrand;
